export const comnEnvs = {
    base: `${process.env.REACT_APP_BASE}`,
    base_comn: `${process.env.REACT_APP_BASE_COMN}`,
    locale: {
        ko: "ko-KR",
        en: "en-TZ",
        tz: "sw-TZ",
    },
    url: {
        // external
        osci: process.env.REACT_APP_URL_OSCI,
    },
    popup: {
        comnCd: "comn:comnCd",
        cityCd: "comn:cityCd",
        unLocCd: "comn:unLocCd",
        cntyCd: "comn:cntyCd",
        dgt3CntyCd: "comn:dgt3CntyCd",
        dgt3NumCntyCd: "comn:dgt3NumCntyCd",
        bnkCd: "comn:bnkCd",
        currCd: "comn:currCd",
        portCd: "comn:portCd",
        portAirptCd: "comn:portAirptCd",
        airptCd: "comn:airptCd",
        prcssStatCd: "comn:prcssStatCd",
        orgCd: "comn:orgCd",
        wrhsCd: "comn:wrhsCd",
        carrCd: "comn:carrCd",
        coDclaCd: "comn:coDclaCd",
        orgDeptCd: "comn:orgDeptCd",
        cstmCd: "comn:cstmCd",
        cstmOfcrCd: "comn:cstmOfcrCd",
        cstmOrgzCd: "comn:cstmOrgzCd",
        vhclBodyCd: "comn:vhclBodyCd",
        vhclCtgrCd: "comn:vhclCtgrCd",
        vhclClrCd: "comn:vhclClrCd",
        vhclFlCd: "comn:vhclFlCd",
        vhclMkerCd: "comn:vhclMkerCd",
        vhclImpCntyCd: "comn:vhclImpCntyCd",
        vhclInsrTpCd: "comn:vhclInsrTpCd",
        vhclMdlCd: "comn:vhclMdlCd",
        vhclMdlNoCd: "comn:vhclMdlNoCd",
        vhclHlpnCtgrCd: "comn:vhclHlpnCtgrCd",
        vhclPrplTpCd: "comn:vhclPrplTpCd",
        vhclTrmssnTpCd: "comn:vhclTrmssnTpCd",
        vhclUseCd: "comn:vhclUseCd",
        hsCd: "comn:hsCd",
        postCd: "comn:postCd",
        trmnlOptrCd: "comn:trmnlOptrCd",
        tb: "comn:tb",
        indvCdTb: "comn:indvCdTb",
        col: "comn:col",
        indvCdCol: "comn:indvCdCol",
        lbl: "comn:lbl",
        comnCdMstr: "comn:comnCdMstr",
        dclt: "comn:dclt",
        coUsr: "comn:coUsr",
        orgUsr: "comn:orgUsr",
        coBucn: "comn:coBucn",
        orgz: "comn:orgz",
        orgzSub: "comn:orgzSub",
        hldy: "comn:hldy",
        csldrTin: "comn:csldrTin",
        roleCd: "comn:roleCd",
        profile: "comn:profile",
        prflCo: "comn:prflCo",
        prflCsbr: "comn:prflCsbr",
        prflCsbrCo: "comn:prflCsbrCo",
        prflHscd: "comn:prflHscd",
    },
};
